import styled from 'styled-components';
import { primitives } from '@veneer/primitives';

const { color, typography } = primitives;

export const Container = styled.div`
  padding: 0;
  background: ${color.white};
`;

export const Title = styled.h2`
  font-family: ${typography.family0};
  color: ${color.gray12};
  font-size: ${typography.size5};
  line-height: ${typography.lineHeight5};
  font-weight: ${typography.weight4};
  margin-bottom: 32px;
  text-align: left;
`;

export const DropdownSection = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 32px;
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 100%;
`;

export const DropdownContainer = styled.div`
  flex: 1;
`;

export const PrinterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
`;

export const PrinterCard = styled.div`
  background: ${color.white};
  transition: all 0.2s ease;
  position: relative;
  min-height: 800px;
  display: flex;
  flex-direction: column;
`;

export const PrinterImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px;
  margin-bottom: 12px;
  padding: 8px;
  background: ${color.white};
  border-bottom: 1px solid ${color.gray12};
`;

export const PrinterImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

export const FullSpecsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80px;
`;

export const SpecsLinkButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  cursor: pointer;
  margin-bottom: 4px;
  padding: 0;

  svg {
    color: ${color.electricBlue7};
    flex-shrink: 0;
  }
  span {
    color: ${color.electricBlue7};
    text-decoration: underline;
    font-family: ${typography.family0};
    font-size: ${typography.size2};
    line-height: ${typography.lineHeight2};
  }

  &:hover {
    svg {
      color: ${color.electricBlue8};
    }
    span {
      color: ${color.electricBlue8};
    }
  }
`;
export const PdfLabel = styled.span`
  font-size: ${typography.size1};
  color: ${color.gray12};
  font-family: ${typography.family0};
`;

export const Divider = styled.div`
  border-bottom: 1px solid ${color.gray12};
`;

export const FeaturesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  color: ${color.gray12};
`;
